export default __webpack_public_path__ + "static/media/roboto-latin-700italic.7d8125ff.woff2";